import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment-timezone';

import { withTranslation, Trans } from 'react-i18next';
import { Message, Flag, Form, Input, Button, Checkbox, Dropdown, Label, Grid, Icon, Segment, Statistic } from 'semantic-ui-react';
import UploadFileModal from '../components/upload/uploadFileModal';
import UploadFileZone from '../components/upload/uploadFileZone';
import QueueModel from '../models/queueModel';
import StatsQueueModel from '../models/statsQueue';
import QueueChart from './queue/queueChart';
import MessageBlock from '../nacre/components/message';

import TooltipIcon from './common/tooltip-icon';

// Small hack for now, in the future everything will be in the same folder
import Style from './queue/components/queue-stats/queue-stats.module.css';
import { Loader } from '@weezevent/nacre';

class Queue extends React.Component {
    constructor(...args) {
        super(...args);
        const { reloadTime } = this.props;

        this.state = {
            showUploadFile: false,
            timer: setTimeout(() => {
                this.getData();
            }, reloadTime * 1000),
            previousQueue: [],
            formWaitingTime: null,
            formThresholdStep: null,
            formDisplayRank: false,
            formImage: null,
            formVideo: null,
            formTranslations: {},
            formDate: '',
            formEnableLetInLimit: false,
            formLetInLimit: null,
            displayDatePicker: false,
            displayForm: false,
            isUploadingFile: false,
            estimatedWaiting: {
                current: 0,
                previous: []
            },
            displaySuccessMessage: false,
            queue: null,
            stats: null,
            widgetStats: null
        };
    }
    getData() {
        const newEstimatedWaiting = this.state.queue ? Math.round((this.state.queue.activeCount / this.state.queue.thresholdStep) * this.state.queue.thresholdDuration) : null;
        const { previousQueue, queue } = this.state;
        if (queue) {
            this.setState({
                previousQueue: [queue, ...previousQueue]
            });
        }
        this.setState(
            {
                estimatedWaiting: {
                    current: newEstimatedWaiting,
                    previous: [this.state.estimatedWaiting.current, ...this.state.estimatedWaiting.previous]
                },
                timer: setTimeout(() => {
                    this.updateData();
                }, this.props.reloadTime * 1000)
            },
            () => {
                let queuePromise = QueueModel.get({
                    organizationId: this.props.organization.id,
                    eventId: this.props.event.id,
                    widgetKey: this.props.widgetKey
                });
                let widgetStatsPromise = this.props.widgetKey
                    ? StatsQueueModel.get({
                          organizationId: this.props.organization.id,
                          widgetKey: this.props.widgetKey
                      })
                    : null;
                let statsPromise = StatsQueueModel.get({
                    organizationId: this.props.organization.id,
                    eventId: this.props.event.id
                });
                Promise.all([queuePromise, widgetStatsPromise, statsPromise])
                    .then(([queue, widgetStats, stats]) => {
                        const newEstimatedWaiting = Math.round((queue.activeCount / queue.thresholdStep) * queue.thresholdDuration);
                        this.setState({
                            formWaitingTime: queue.thresholdDuration,
                            formThresholdStep: queue.thresholdStep,
                            formDisplayRank: queue.displayRank,
                            formDate: queue.openDate,
                            formImage: queue.imageDetail,
                            formVideo: queue.videoDetail,
                            formEnableLetInLimit: queue.letInLimit !== null,
                            formLetInLimit: queue.letInLimit,
                            estimatedWaiting: {
                                current: newEstimatedWaiting,
                                previous: []
                            },
                            queue,
                            stats,
                            widgetStats
                        });
                    })
                    .catch(e => {});
            }
        );
    }

    updateData() {
        const newEstimatedWaiting = this.state.queue ? Math.round((this.state.queue.activeCount / this.state.queue.thresholdStep) * this.state.queue.thresholdDuration) : null;
        const { previousQueue, queue } = this.state;
        if (queue) {
            this.setState({
                previousQueue: [queue, ...previousQueue]
            });
        }
        this.setState(
            {
                estimatedWaiting: {
                    current: newEstimatedWaiting,
                    previous: [this.state.estimatedWaiting.current, ...this.state.estimatedWaiting.previous]
                },
                timer: setTimeout(() => {
                    this.updateData();
                }, this.props.reloadTime * 1000)
            },
            () => {
                let queuePromise = QueueModel.get({
                    organizationId: this.props.organization.id,
                    eventId: this.props.event.id,
                    widgetKey: this.props.widgetKey
                });

                let widgetStatsPromise = this.props.widgetKey
                    ? StatsQueueModel.get({
                          organizationId: this.props.organization.id,
                          widgetKey: this.props.widgetKey
                      })
                    : new Promise(() => {});

                let statsPromise = StatsQueueModel.get({
                    organizationId: this.props.organization.id,
                    eventId: this.props.event.id
                });
                Promise.all([queuePromise, widgetStatsPromise, statsPromise])
                    .then(([queue, widgetStats, stats]) => {
                        this.setState({
                            queue,
                            stats,
                            widgetStats
                        });
                    })
                    .catch(e => {});
            }
        );
    }
    componentDidMount() {
        this.getData();
    }

    clearForm(prop) {
        this.setState({
            [prop]: null
        });
    }

    renderDifferentiel(current, previous) {
        const diff = Math.round(current - previous);

        if (!current || !previous) {
            return null;
        }
        if (previous === 0) {
            return null;
        }
        if (diff === 0) {
            return <p className="differentiel">-</p>;
        }

        return <p className="differentiel">{diff > 0 ? '+' + diff : diff}</p>;
    }

    renderLastPassed() {
        const { previousQueue, queue } = this.state;

        const previousWaitingTime = previousQueue.length ? previousQueue[0].waitingTime : 0;
        const currentWaitingTime = queue ? queue.waitingTime : 0;

        let displayTime = moment()
            .startOf('day')
            .seconds(currentWaitingTime)
            .format('H:mm:ss');

        return (
            <Statistic className="participants-container">
                <Statistic.Value>{displayTime}</Statistic.Value>
                <Statistic.Label>
                    <Icon name="sign-in" />
                    <Trans i18nKey="ticket.queue.stats.lastPassed">last passed</Trans>
                </Statistic.Label>
                {this.renderDifferentiel(currentWaitingTime, previousWaitingTime)}
            </Statistic>
        );
    }

    renderRealInQueue() {
        const { previousQueue, queue } = this.state;
        return (
            <Statistic className="participants-container">
                <Statistic.Value>{queue ? queue.activeCount : 0}</Statistic.Value>
                <Statistic.Label>
                    <Icon name="users" />
                    <Trans i18nKey="ticket.queue.stats.realInQueue">In queue (real)</Trans>
                    <TooltipIcon content={this.props.t('ticket.queue.stats.realInQueue_tooltip')} />
                </Statistic.Label>
                {this.renderDifferentiel(queue ? queue.activeCount : 0, previousQueue.length ? previousQueue[0].activeCount : 0)}
            </Statistic>
        );
    }

    renderBan() {
        const { previousQueue, queue } = this.state;

        const previousDistributorId = previousQueue.length ? previousQueue[0].distributorId : 0;
        const previousThresholdValue = previousQueue.length ? previousQueue[0].thresholdValue : 0;
        const currentDistributorId = queue ? queue.distributorId : 0;
        const currentThresholdValue = queue ? queue.thresholdValue : 0;
        const previousInQueue = previousQueue.length ? previousQueue[0].activeCount : 0;
        const currentInQueue = queue ? queue.activeCount : 0;

        const previousCounter = previousDistributorId - previousThresholdValue - previousInQueue;
        const currentCounter = currentDistributorId - currentThresholdValue - currentInQueue;

        return (
            <Statistic className="participants-container">
                <Statistic.Value>{currentCounter > 0 ? currentCounter : 0}</Statistic.Value>
                <Statistic.Label>
                    <Icon name="ban" />
                    <Trans i18nKey="ticket.queue.stats.quiting">users quiting</Trans>
                    <TooltipIcon content={this.props.t('ticket.queue.stats.quit_tooltip')} />
                </Statistic.Label>
                {this.renderDifferentiel(currentCounter > 0 ? currentCounter : 0, previousCounter > 0 ? previousCounter : 0)}
            </Statistic>
        );
    }

    renderMaxIn() {
        const { queue } = this.state;

        const { let_in_limit, let_in_count } = queue;
        if (let_in_limit === null) {
            return null;
        }

        const threshold_reached = queue.isFull ? Style['queue-threshold-reached'] : '';

        return (
            <Statistic className={`participants-container ${threshold_reached}`}>
                <Statistic.Value>
                    {let_in_count}
                    <span className="participants-max-count">/ {let_in_limit}</span>
                </Statistic.Value>
                <Statistic.Label>
                    <Icon name="users" />
                    <Trans i18nKey="ticket.queue.stats.max_in" />
                    <TooltipIcon content={this.props.t('ticket.queue.stats.max_in_tooltip')} />
                </Statistic.Label>
            </Statistic>
        );
    }

    renderWaitingTime() {
        const { estimatedWaiting } = this.state;

        let displayTime = moment()
            .startOf('day')
            .seconds(estimatedWaiting.current)
            .format('H:mm:ss');

        return (
            <Statistic className="participants-container">
                <Statistic.Value>{displayTime}</Statistic.Value>
                <Statistic.Label>
                    <Icon name="clock" />
                    <Trans i18nKey="ticket.queue.stats.waitingTime">ETA (th)</Trans>
                    <TooltipIcon content={this.props.t('ticket.queue.stats.waitingTime_tooltip')} />
                </Statistic.Label>
                {this.renderDifferentiel(estimatedWaiting.current, estimatedWaiting.previous.length ? estimatedWaiting.previous[0] : 0)}
            </Statistic>
        );
    }

    renderConfig() {
        const { queue } = this.state;
        return (
            <Statistic className="participants-container">
                <Statistic.Value>
                    {queue.thresholdStep}
                    <Icon name="users" />
                </Statistic.Value>
                <Statistic.Label style={{ textTransform: 'lowercase' }}>/{queue.thresholdDuration}s</Statistic.Label>
            </Statistic>
        );
    }
    renderTicketInformations() {
        const { queue } = this.state;
        return (
            <div>
                <p className="label-queue title">
                    <Trans i18nKey="ticket.queue.about.title">Settings about the queue</Trans>
                </p>
                <p className="label-queue">
                    <Trans i18nKey="ticket.queue.about.lastEmited">Last emited ticket:</Trans> <span className="value">{queue.distributorId}</span>
                </p>
                <p className="label-queue">
                    <Trans i18nKey="ticket.queue.about.lastGranted">Last granted ticket:</Trans> <span className="value">{queue.thresholdValue}</span>
                </p>
                {queue.letInLimit !== null ? (
                    <p className="label-queue">
                        <Trans i18nKey="ticket.queue.about.limitEntrance">Limit entrance</Trans>{' '}
                        <span className="value">
                            {queue.letInCount} / {queue.letInLimit}
                        </span>
                    </p>
                ) : null}
            </div>
        );
    }
    countTranslations(language) {
        const { queue } = this.state;
        if (!queue) {
            return null;
        }
        if (
            !Object.keys(queue.translations).length ||
            !Object.keys(queue.translations.custom_text).length ||
            !Object.prototype.hasOwnProperty.call(queue.translations.custom_text, language)
        ) {
            return 0;
        }
        return Object.keys(queue.translations.custom_text[language]).length;
    }
    renderLanguages() {
        const { event } = this.props;
        const languages = event.languages;
        const tabs = [];
        languages.map(language => {
            tabs.push(
                <p key={language} className="label-queue">
                    <Flag name={language.length === 2 ? language : language.split('-')[1].toLowerCase()} /> {language} : {this.countTranslations(language)}
                </p>
            );
            return null;
        });
        return tabs;
    }

    submitForm() {
        const { formThresholdStep, formWaitingTime, formDisplayRank, formTranslations, formImage, formVideo, formDate, formEnableLetInLimit, formLetInLimit, queue } = this.state;

        let custom_text = {};

        Object.entries(formTranslations).map(([language]) => {
            Object.entries(formTranslations[language]).map(([key]) => {
                if (formTranslations[language][key].custom) {
                    if (!custom_text[language]) {
                        custom_text[language] = {};
                    }
                    if (!custom_text[language][key]) {
                        custom_text[language][key] = {};
                    }
                    custom_text[language][key] = formTranslations[language][key].value;
                }
                return null;
            });
            return null;
        });

        queue.threshold_duration = formWaitingTime;
        queue.threshold_step = formThresholdStep;
        queue.display_rank = formDisplayRank;
        queue.image = formImage ? formImage.uuid : null;
        queue.video = formVideo ? formVideo.uuid : null;
        queue.translations = {};
        queue.let_in_limit = formEnableLetInLimit ? formLetInLimit : null;

        if (formDate && formDate !== '') {
            const date = new Date(formDate).getTime();

            queue.open_date = moment(date)
                .tz(this.props.event.timezone)
                .format();
        }

        if (Object.keys(custom_text).length) {
            queue.translations = { custom_text: custom_text };
        }
        this.setState({
            displayForm: false,
            displaySuccessMessage: true,
            queue: queue
        });
        window.scrollTo(0, 0);
        queue
            .save({
                organizationId: this.props.organization.id,
                eventId: this.props.event.id,
                widgetKey: this.props.widgetKey
            })
            .then(response => {
                this.setState({ displaySuccessMessage: false });
            });
    }

    handleCheckboxChange = (e, data) => {
        this.setState({ [data.name]: data.checked });
    };

    handleChange = (e, { name, value }) => {
        this.setState({ [name]: value });
        if (name === 'formDate') {
            this.setState({ displayDatePicker: false });
        }
    };

    toggleDatePicker() {
        this.setState({ displayDatePicker: !this.state.displayDatePicker });
    }

    renderFormEditQueue() {
        const { displayForm, queue } = this.state;

        if (!queue) {
            return;
        }

        if (displayForm) {
            const waitingOptions = [
                { key: 10, value: 10, text: '10s' },
                { key: 15, value: 15, text: '15s' },
                { key: 20, value: 20, text: '20s' },
                { key: 25, value: 25, text: '25s' },
                { key: 30, value: 30, text: '30s' },
                { key: 35, value: 35, text: '35s' },
                { key: 40, value: 40, text: '40s' },
                { key: 45, value: 45, text: '45s' },
                { key: 50, value: 50, text: '50s' },
                { key: 55, value: 55, text: '55s' },
                { key: 60, value: 60, text: '60s' }
            ];

            return (
                <Segment>
                    <h3>
                        <Trans i18nKey="ticket.queue.form.title">Edit queue parameters</Trans>
                    </h3>
                    <Form className="form-edit-queue">
                        <Form.Field>
                            <label>
                                <Trans i18nKey="ticket.queue.form.label.waitingTime">Waiting time between waves</Trans>
                            </label>
                            <Dropdown
                                fluid
                                selection
                                placeholder="10s"
                                options={waitingOptions}
                                name="formWaitingTime"
                                value={this.state.formWaitingTime}
                                onChange={this.handleChange.bind(this)}
                            />
                        </Form.Field>
                        <Form.Field>
                            <label>
                                <Trans i18nKey="ticket.queue.form.label.numberPerWave">People per wave</Trans>
                            </label>
                            <Input
                                placeholder="1000"
                                labelPosition="right"
                                type="number"
                                name="formThresholdStep"
                                value={this.state.formThresholdStep || ''}
                                onChange={this.handleChange.bind(this)}
                            >
                                <input />
                                <Label>
                                    <Icon name="users" />
                                </Label>
                            </Input>
                        </Form.Field>
                        <Form.Field>
                            <label>
                                <Trans i18nKey="ticket.queue.form.label.letInLimitBool">Limit total people in</Trans>
                                <TooltipIcon content={this.props.t('ticket.queue.form.letInLimitTooltip')} iconStyle={{ fontSize: '1.2rem' }} />
                            </label>
                            <Checkbox toggle name="formEnableLetInLimit" checked={this.state.formEnableLetInLimit} onChange={this.handleCheckboxChange.bind(this)} />
                            {this.state.formEnableLetInLimit ? (
                                <React.Fragment>
                                    <Input
                                        placeholder="1000"
                                        labelPosition="right"
                                        type="number"
                                        name="formLetInLimit"
                                        value={this.state.formLetInLimit}
                                        onChange={this.handleChange.bind(this)}
                                    >
                                        <input />
                                        <Label>
                                            <Icon name="warning" />
                                        </Label>
                                    </Input>
                                </React.Fragment>
                            ) : null}
                        </Form.Field>
                        <Form.Field>
                            <label>
                                <Trans i18nKey="ticket.queue.form.label.displayRank">Display rank</Trans>
                            </label>
                            <Checkbox toggle name="formDisplayRank" checked={this.state.formDisplayRank} onChange={this.handleCheckboxChange.bind(this)} />
                        </Form.Field>
                        <Form.Field>
                            <label>
                                <Trans i18nKey="ticket.queue.form.label.logo">Video</Trans>
                            </label>
                            <br />
                            {this.renderLogo(this.state.formImage)}
                            {this.state.formImage && (
                                <Button
                                    negative
                                    onClick={synth => {
                                        synth.preventDefault();
                                        this.clearForm('formImage');
                                    }}
                                >
                                    <Trans i18nKey="ticket.queue.form.logo.removeLogo">Remove image</Trans>
                                </Button>
                            )}
                            <Button
                                primary
                                onClick={synth => {
                                    synth.preventDefault();
                                    this.setState({ showUploadFile: 'image' });
                                }}
                            >
                                <Trans i18nKey="ticket.queue.form.logo.uploadLogo">Upload image</Trans>
                            </Button>

                            {this.renderLogo(this.state.formVideo)}
                            {this.state.formVideo && (
                                <Button
                                    negative
                                    onClick={synth => {
                                        synth.preventDefault();
                                        this.clearForm('formVideo');
                                    }}
                                >
                                    <Trans i18nKey="ticket.queue.form.logo.removeVideo">Remove video</Trans>
                                </Button>
                            )}
                            <Button
                                primary
                                onClick={synth => {
                                    synth.preventDefault();
                                    this.setState({ showUploadFile: 'video' });
                                }}
                            >
                                <Trans i18nKey="ticket.queue.form.logo.uploadVideo">Upload video</Trans>
                            </Button>
                        </Form.Field>
                        <div className="footer">
                            <Button type="button" onClick={this.toggleForm.bind(this)}>
                                <Trans i18nKey="ticket.common.action.cancel">Cancel</Trans>
                            </Button>
                            <Button primary onClick={this.submitForm.bind(this)}>
                                <Trans i18nKey="ticket.common.action.edit">Save</Trans>
                            </Button>
                        </div>
                    </Form>
                </Segment>
            );
        }

        return null;
    }
    toggleForm() {
        window.scrollTo(0, 0);
        this.setState({
            displayForm: !this.state.displayForm
        });
    }

    setSelectedImage(file) {}

    renderButtonEditForm() {
        const { displayForm, queue } = this.state;

        if (!queue) {
            return;
        }

        const name = displayForm ? 'close' : 'cog';

        return (
            <Button className="cta-edit-queue" icon onClick={this.toggleForm.bind(this)}>
                <Icon name={name} />
            </Button>
        );
    }

    displaySuccessMessage() {
        const { t } = this.props;
        if (this.state.displaySuccessMessage) {
            return (
                <MessageBlock
                    title={
                        <span>
                            {' '}
                            <Icon name="check" /> {t('ticket.queue.message.success.title')}
                        </span>
                    }
                />
            );
        }

        return null;
    }

    renderContent() {
        const { queue } = this.state;

        if (!queue) {
            return;
        }

        let columns = [this.renderRealInQueue()];

        if (queue.let_in_limit !== null) {
            columns.push(this.renderMaxIn());
        }

        columns.push(this.renderBan(), this.renderWaitingTime());

        return (
            <Grid className="overview-container" columns={columns.length}>
                <Grid.Row>
                    {columns.map((col, i) => (
                        <Grid.Column key={i}>
                            <Segment>{col}</Segment>
                        </Grid.Column>
                    ))}
                </Grid.Row>
            </Grid>
        );
    }

    renderContentQueue() {
        const { queue } = this.state;
        if (!queue) {
            return;
        }
        return (
            <Segment>
                <Grid className="overview-container">
                    <Grid.Row>
                        <Grid.Column mobile={16} tablet={6} computer={4}>
                            {this.renderConfig()}
                        </Grid.Column>
                        <Grid.Column mobile={16} tablet={6} computer={6}>
                            {this.renderTicketInformations()}
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Segment>
        );
    }

    renderCharts() {
        const { stats, widgetStats } = this.state;
        return (
            <div>
                <QueueChart stats={widgetStats} title={this.props.t('ticket.queue.charts.widget', { widgetKey: this.props.widgetKey })} />
                <QueueChart stats={stats} title={this.props.t('ticket.queue.charts.event', { event: this.props.event })} />
            </div>
        );
    }

    renderContainer() {
        const { organization, event } = this.props;
        const { stats, queue } = this.state;

        if ((!queue && organization && event) || !stats) {
            return <Loader inline="centered" />;
        }

        return (
            <div>
                {this.displaySuccessMessage()}
                {this.renderFormEditQueue()}
                {this.renderContentQueue()}
                {this.renderContent()}
                {queue.isFull && (
                    <Message icon negative>
                        <Icon name="exclamation circle" size="big" style={{ fontSize: '2em', alignSelf: 'baseline' }} />
                        <Message.Content>
                            <Trans i18nKey="ticket.queue.warning_queue_full" />
                        </Message.Content>
                    </Message>
                )}
                {this.renderCharts()}
            </div>
        );
    }

    renderLogo(formValue) {
        if (!formValue) {
            return null;
        }

        const { url, path } = formValue;

        let basename = /\/[^/]+\.\w{2,4}$/.exec(path)[0];
        if (!basename) {
            // Maybe a warning?
            return null;
        }

        let [, extension] = basename.replace('/', '').split('.');
        if (extension.toLowerCase() === 'mp4') {
            // render video
            return (
                <video controls className="queue-preview-image">
                    <source src={url} type="video/mp4" />
                </video>
            );
        }

        return <img alt="queue logo" className="queue-preview-image" src={url} />;
    }

    render() {
        return (
            <div className="queue">
                {this.props.event && (
                    <UploadFileModal
                        header={
                            <Trans i18nKey={this.state.showUploadFile === 'image' ? 'ticket.queue.form.logo.uploadLogo' : 'ticket.queue.form.logo.uploadVideo'}>Upload image</Trans>
                        }
                        open={Boolean(this.state.showUploadFile)}
                        organization={this.props.organization}
                        eventId={this.props.event.id}
                        onClose={() => this.setState({ showUploadFile: false })}
                        onError={() => {}}
                        onUpload={image => {
                            const formValue = this.state.showUploadFile === 'image' ? 'formImage' : 'formVideo';
                            this.setState({
                                [formValue]: image,
                                showUploadFile: false
                            });
                        }}
                        fileTypes={this.state.showUploadFile === 'image' ? UploadFileZone.imageFileTypes : ['.mp4']}
                        getQueryParams={() => ({
                            type: this.state.showUploadFile
                        })}
                    />
                )}
                <h1 className="header">
                    <Trans i18nKey="ticket.queue.title">Queue</Trans> {this.renderButtonEditForm()}
                </h1>
                {this.renderContainer()}
            </div>
        );
    }
}

Queue.propTypes = {
    event: PropTypes.object,
    organization: PropTypes.object,
    widgetKey: PropTypes.string,
    reloadTime: PropTypes.number,
    t: PropTypes.func.isRequired
};

Queue.defaultProps = {
    reloadTime: 10 // time in seconds
};

export default withTranslation()(Queue);
